import axios from 'axios';
export const baseURL = process.env.NODE_ENV === 'production'
  ? 'https://aae-api.scszsj.com'
  : 'https://aae-api.scszsj.com';
// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: baseURL+url,
        headers: {
            'Content-Type': 'application/json',
        },
        data: params,
    }).then(res => {
        // console.log(res,'成功')
        // 可在此统一处理响应数据格式
        if (res.status >= 200 && res.status < 300) {
          return res.data;
        } else {
          return Promise.reject(res.data);
        }
      }
    )
    .catch(error => {
        // 统一错误处理
        const errorMsg = error.response?error.response.data:'请求失败，请检查网络或参数';
        return errorMsg;
  });
};
// 通用公用方法
const req = (method, url, params, options = {}) => {
    return axios({
        method: method,
        url: baseURL+url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('logintoken')
            // token: localStorage.getItem('logintoken')
        },
        data: params,
        // traditional: true,
        // transformRequest: [
        //     function(data) {
        //         let ret = ''
        //         for (let it in data) {
        //             ret +=
        //                 encodeURIComponent(it) +
        //                 '=' +
        //                 encodeURIComponent(data[it]) +
        //                 '&'
        //         }
        //         return ret
        //     }
        // ]
    }).then(res => {
        if (options.returnResponse) {
          return {
            status: res.status,
            data: res.data
          };
        }
        // console.log(res,'成功')
        if(res.detail=='无效的令牌格式'||res.detail=='令牌已过期'){
          //this.$message.error(res.detail)
          setTimeout(() => {
          this.$store.commit('logout', 'false')
          this.$router.push({ path: '/login' })
          // this.$message({
          //   type: 'success',
          //   message: '已退出登录!'
          // })
         }, 1000)
        }
        // 可在此统一处理响应数据格式
        if (res.status == 204) {
          // console.log(res.status,'成功成功成功成功')
          return 204;
        }
        // 可在此统一处理响应数据格式
       else if (res.status == 200) {
          return res.data;
        } else {
          return Promise.reject(res.data);
        }
      }
    )
    .catch(error => {
        // 统一错误处理
        const errorMsg = error.response ? error.response.data : '请求失败，请检查网络或参数';
        console.log(errorMsg, 6666666666666666666666666666666);
        // 针对未认证、令牌无效或过期，直接跳转到当前服务器的登录页
        if (
          errorMsg.detail === "无效的令牌格式" ||
          errorMsg.detail === "令牌已过期" ||
          errorMsg.detail === "Not authenticated"
        ){
          // if (window.Vue && window.Vue.prototype.$message) {
          //   window.Vue.prototype.$message.error(errorMsg.detail);
          // } else if (window.Element && window.Element.Message) {
          //   window.Element.Message.error(errorMsg.detail);
          // } else {
          //   // 兜底
          //   alert(errorMsg.detail);
          // }
          setTimeout(() => {
            localStorage.removeItem('logintoken');
            localStorage.removeItem('userInfo');
            const { protocol, host } = window.location;
            window.location.href = `${protocol}//${host}/#/login`;
          }, 1000);
          return;
        }
        return errorMsg;
  });
};

// GET请求方法
const reqs = (method, url, params) => {
    return axios({
        method: method,
        url: baseURL+url,
        headers: {
            'Authorization': localStorage.getItem('logintoken')
        },
        params: params,
      }).then(res => {

          if(res.detail=='无效的令牌格式'||res.detail=='令牌已过期'){
            //this.$message.error(res.detail)
            setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 1000)
          return;
          }
        // 可在此统一处理响应数据格式
        if (res.status >= 200 && res.status < 300) {
          return res.data;
        } else {
          return Promise.reject(res.data);
        }
      }
    )
    .catch(error => {
        // 统一错误处理
        const errorMsg = error.response ? error.response.data : '请求失败，请检查网络或参数';
        console.log(errorMsg, 6666666666666666666666666666666);
        // 针对未认证、令牌无效或过期，直接跳转到当前服务器的登录页
        if (
          errorMsg.detail === "无效的令牌格式" ||
          errorMsg.detail === "令牌已过期" ||
          errorMsg.detail === "Not authenticated"
        ){
          // 使用 Element UI 的方式进行错误提示
          // if (window.Vue && window.Vue.prototype.$message) {
          //   window.Vue.prototype.$message.error(errorMsg.detail);
          // } else if (window.Element && window.Element.Message) {
          //   window.Element.Message.error(errorMsg.detail);
          // } else {
          //   // 兜底
          //   alert(errorMsg.detail);
          // }
          setTimeout(() => {
            localStorage.removeItem('userInfo');
            localStorage.removeItem('logintoken');
            const { protocol, host } = window.location;
            window.location.href = `${protocol}//${host}/#/login`;
          }, 1000);
          return;
        }
        return errorMsg;
  });
};
//Upload文件上传 参数在body中
const upload = (method, url, params, options = {}) => {
    return axios({
        method: method,
        url: baseURL+url,
        headers: {
            'Authorization': localStorage.getItem('logintoken'),
            'Content-Type': 'multipart/form-data'
        },
        data: params,
        onUploadProgress: options.onUploadProgress,
    }).then(res => {
        if (options.returnResponse) {
          return {
            status: res.status,
            data: res.data
          };
        }
        if (res.status >= 200 && res.status < 300) {
          return res.data;
        }
        return Promise.reject(res.data);
    })
    .catch(error => {
      // 统一错误处理
      const errorMsg = error.response?error.response.data:'请求失败，请检查网络或参数';
      if(errorMsg.detail=="无效的令牌格式"||errorMsg.detail=="令牌已过期"){
        console.log(errorMsg,1111)
        setTimeout(() => {
        // 由于此处是工具函数文件，无法直接使用this.$router
        // 可以通过window.location实现跳转
        localStorage.removeItem('logintoken');
        window.location.href = '/login';
      }, 1000)
      return;
      }
      return errorMsg;
});
}

export {
    loginreq,
    req,
    reqs,
    upload
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js